/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step2Inputs */

const en_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const de_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Analyse`)
};

const fr_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const es_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const it_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const nl_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const pl_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const fi_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const da_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

const sv_landing_workflow_step2 = /** @type {(inputs: Landing_Workflow_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis`)
};

/**
* | output |
* | --- |
* | "AI Analysis" |
*
* @param {Landing_Workflow_Step2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_step2 = /** @type {((inputs?: Landing_Workflow_Step2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_workflow_step2(inputs)
	if (locale === "fr") return fr_landing_workflow_step2(inputs)
	if (locale === "es") return es_landing_workflow_step2(inputs)
	if (locale === "it") return it_landing_workflow_step2(inputs)
	if (locale === "nl") return nl_landing_workflow_step2(inputs)
	if (locale === "pl") return pl_landing_workflow_step2(inputs)
	if (locale === "fi") return fi_landing_workflow_step2(inputs)
	if (locale === "da") return da_landing_workflow_step2(inputs)
	if (locale === "sv") return sv_landing_workflow_step2(inputs)
	return en_landing_workflow_step2(inputs)
});